export enum CustomerFormQuestionTypes {
    None = 0,
    DatePicker = 1 << 0,    // 0001 -- the bitshift is unnecessary, but done for consistency
    AddressFinder = 1 << 1, // 0010
    BankAccount = 1 << 2,   // 0100
    FileUpload = 1 << 3,    // 0101
}